import { useState } from 'react';
import { Button } from '@/design-system';
import { api, ApiError } from '@/lib/api';
import { COPY } from './copy';
import styles from './ApplicantLayout.module.css';

/** What happens to an applicant's data, and how to ask for it to be deleted (SPEC, Security). */
export function YourData() {
  const [state, setState] = useState<'idle' | 'confirming' | 'sending' | 'sent' | 'failed'>('idle');
  const [message, setMessage] = useState('');

  async function send() {
    setState('sending');
    try {
      const { message: said } = await api.post<{ message: string }>('/api/applicant/deletion-request');
      setMessage(said);
      setState('sent');
    } catch (e) {
      setMessage(e instanceof ApiError ? e.message : COPY.deletionFailed);
      setState('failed');
    }
  }

  return (
    <section className={styles.yourData} aria-labelledby="your-data">
      <h2 id="your-data" className={styles.yourDataTitle}>
        {COPY.yourData}
      </h2>
      <p>{COPY.yourDataText}</p>
      {state === 'idle' && (
        <Button variant="secondary" size="sm" onClick={() => setState('confirming')}>
          {COPY.askDeletion}
        </Button>
      )}
      {(state === 'confirming' || state === 'sending') && (
        <div className={styles.confirm}>
          <p>{COPY.askDeletionConfirm}</p>
          <div className={styles.confirmActions}>
            <Button size="sm" disabled={state === 'sending'} onClick={() => void send()}>
              {COPY.sendDeletion}
            </Button>
            <Button variant="ghost" size="sm" onClick={() => setState('idle')}>
              {COPY.keepData}
            </Button>
          </div>
        </div>
      )}
      <p role="status" className={state === 'failed' ? styles.failed : undefined}>
        {state === 'sent' || state === 'failed' ? message : ''}
      </p>
    </section>
  );
}
